module.exports = __webpack_public_path__ + "img/intro@2x.0a2e0dd7.png";